<!--
  Created by Ibun
-->
<template>
  <div class="preloader" id="preloader" v-show="show">
    <div class="preloader-content">
      <img
        src="@/assets/images/loading.gif"
        style="width: 170%"
        alt="preloader"
      />
    </div>
  </div>
  <!-- <v-dialog
    ref="dialog"
    :value="show"
    persistent
    max-width="100"
    class="transparent"
  > -->
  <!-- <v-div fill-height class="py-5 transparent">
      <v-layout justify-center align-center> -->
  <!-- <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
          color="primary"
        >
        </v-progress-circular> -->
  <!-- <v-img src="@/assets/images/loading.gif" style="width: 100%"></v-img> -->
  <!-- </v-layout> -->
  <!-- <v-layout v-if="text" mt-5 title justify-center align-center>
        {{ text }}
      </v-layout> -->
  <!-- </v-div> -->
  <!-- </v-dialog> -->
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: false
    }
  }
};
</script>

<style>
.transparent .v-dialog {
  box-shadow: none !important;
}
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00000061;
  z-index: 9999;
  transition: background-color 2s ease-out;
}
.preloader-content {
  position: absolute;
  top: 50%;
  width: 50px;
  left: 0;
  right: 0;
  margin: 0 auto;
  margin-top: -50px;
}
</style>
